export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10738.c3170f8e.jpg";